import React, { useState } from 'react';

export interface ImageWithFallbackProps
  extends Omit<React.ComponentPropsWithoutRef<'img'>, 'src' | 'alt'> {
  src: string;
  alt: string;
  fallbackSrc?: string;
  fallbackContent?: React.ReactNode;
}

export function ImageWithFallback({
  src,
  alt,
  fallbackSrc,
  fallbackContent,
  className = '',
  loading,
  ...props
}: ImageWithFallbackProps) {
  const [error, setError] = useState(false);
  const [loaded, setLoaded] = useState(false);

  const handleError = () => setError(true);
  const handleLoad = () => setLoaded(true);

  if (error && fallbackContent) {
    return <div className={className}>{fallbackContent}</div>;
  }

  return (
    <img
      src={error && fallbackSrc ? fallbackSrc : src}
      alt={alt}
      loading={loading ?? 'lazy'}
      decoding="async"
      className={`object-cover ${!loaded && !error ? 'animate-pulse bg-zinc-100' : ''} ${className}`}
      onError={handleError}
      onLoad={handleLoad}
      {...props}
    />
  );
}
